import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuickApplyContainerComponent } from "./quick-apply-container/quick-apply-container.component";
import { QuickApplyRoutingModule } from './quick-apply-routing.module';
import { AngularSvgIconModule  } from "angular-svg-icon";
import { QuickApplySubmitComponent } from "./quick-apply-submit/quick-apply-submit.component";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule, MatLabel } from "@angular/material/form-field";
import { MatButton, MatButtonModule } from "@angular/material/button";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from '@ngx-translate/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from "@angular/material/input";
import { MatCheckbox } from "@angular/material/checkbox";
import { FormsModule } from "@angular/forms";
import { FileUploadComponent } from "./file-upload/file-upload.component";
import { MatIcon } from "@angular/material/icon";
import { MatCard, MatCardContent, MatCardHeader } from "@angular/material/card";
import { QuickApplyStartComponent } from "./quick-apply-start/quick-apply-start.component";
import { QuickApplyOtpComponent } from "./quick-apply-otp/quick-apply-otp.component";
import { QuickApplyPasswordComponent } from "./quick-apply-password/quick-apply-password.component";
import { DragDropDirective } from "../../shared/directives/drag-drop.directive";
import { QuickApplyApiService } from "./quick-apply-api.service";
import { TalentHappyPathAuthService } from "../shared/service/talent-happy-path-auth.service";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { TalentHappyPathTokenInterceptorService } from "../shared/service/talent-happy-path-token-interceptor.service";
import { VideoInterviewStepTokenInterceptor } from "../initial-interview/video-interview/service/video-interview-step-token.interceptor";
import { TalentHappyPathAuthResolver } from "../shared/service/talent-happy-path-auth.resolver";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { QuickApplyWelcomeComponent } from './quick-apply-welcome/quick-apply-welcome.component';
import { InitialInterviewModule } from '../initial-interview/initial-interview.module';
import { QuickApplyInviteComponent } from "./quick-apply-invite/quick-apply-invite.component";
import { LocationPickerComponent } from "../shared/components/location-picker/location-picker.component";
import { InfoContainerComponent } from "../shared/components/info-container/info-container.component";
import { MatSlideToggle } from "@angular/material/slide-toggle";

@NgModule({
  declarations: [
    DragDropDirective,
    FileUploadComponent,
    QuickApplyContainerComponent,
    QuickApplyInviteComponent,
    QuickApplySubmitComponent,
    QuickApplyStartComponent,
    QuickApplyOtpComponent,
    QuickApplyPasswordComponent,
    QuickApplySubmitComponent,
    QuickApplyWelcomeComponent
  ],
  imports: [
    MatButton,
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCheckbox,
    FormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatIcon,
    MatButtonModule,
    MatLabel,
    MatProgressSpinner,
    MatSlideToggle,
    AngularSvgIconModule.forRoot(),
    CommonModule,
    QuickApplyRoutingModule,
    TranslateModule,
    ReactiveFormsModule,
    MatInputModule,
    InitialInterviewModule,
    LocationPickerComponent,
    InfoContainerComponent
  ],
  exports: [FileUploadComponent],
  providers: [
    QuickApplyApiService,
    TalentHappyPathAuthService,
    TalentHappyPathAuthResolver,
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { hideRequiredMarker: true } },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TalentHappyPathTokenInterceptorService,
      multi: true
    },
    {
      // Registered here, beside the funnel's own token interceptor, because this module is imported
      // eagerly by AppModule and so covers every call — including the gather read, which issues a
      // step token outside the quick-apply flow (BIZ-40996).
      provide: HTTP_INTERCEPTORS,
      useClass: VideoInterviewStepTokenInterceptor,
      multi: true
    }
  ]
})
export class QuickApplyModule {}
